import CryptoJS from 'crypto-js'
const keyStr = "cavity12"; //加密密钥
const ivStr = "12cavity"; //矢量

//加密
export function aes_encrypt(word) {
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let iv = CryptoJS.enc.Utf8.parse(ivStr);
    const byteArray = word

    let encrypted = CryptoJS.DES.encrypt(byteArray, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
}